import { createSelector } from '@ngrx/store';
import { getClassroomsState, ClassroomsState } from '..';
import { ClassroomState } from './classroom.reducer';

export const getClassroomState = createSelector(getClassroomsState, (state: ClassroomsState) => state.classroom);

export const getClassroom = createSelector(getClassroomState, (state: ClassroomState) => state.entity);

export const getClassroomDetails = createSelector(getClassroomState, (state: ClassroomState) => state.details);
